import {QuotesContext} from "../context/QuotesContext"

import {useContext} from 'react'

export const useQuotesContext = () => {

    const context = useContext(QuotesContext)

    if(!context){
        throw Error("useQuotesContext must be inside a QuotesContextProvider")
    }

    return context;

    
}